export default "__VITE_ASSET__COPKDSbc__"